"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var temp = function BankTwoTone(primaryColor, secondaryColor) {
    return {
        name: 'bank',
        theme: 'twotone',
        nameWithTheme: 'bank-twotone',
        tag: 'svg',
        attrs: {
            xmlns: 'http://www.w3.org/2000/svg',
            class: 'icon',
            viewBox: '0 0 1024 1024'
        },
        children: [
            {
                tag: 'path',
                attrs: { fill: secondaryColor, d: 'M240.9 393.9h542.2L512 196.7z' },
                children: []
            },
            {
                tag: 'path',
                attrs: {
                    d: 'M894 462c30.9 0 43.8-39.7 18.7-58L530.8 126.2a31.81 31.81 0 0 0-37.6 0L111.3 404c-25.1 18.2-12.2 58 18.8 58H192v374h-72c-4.4 0-8 3.6-8 8v52c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-52c0-4.4-3.6-8-8-8h-72V462h62zM381 836H264V462h117v374zm189 0H453V462h117v374zm190 0H642V462h118v374zM240.9 393.9L512 196.7l271.1 197.2H240.9z',
                    fill: primaryColor
                },
                children: []
            }
        ]
    };
};
temp.nameWithTheme = 'bank-twotone';
var BankTwoTone = temp;
exports.default = BankTwoTone;



//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@1.0.3@@ant-design/icons/lib/twotone/BankTwoTone.js
// module id = 860
// module chunks = 0 1